module.exports = __webpack_public_path__ + "static/media/rorschach_jimmy.517743d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/rorschach_jimmy.mp4
// module id = ySSk
// module chunks = 1